var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19995 9.10986V14.8799C3.19995 16.9999 3.19995 16.9999 5.27995 18.3499L11 21.5299C11.8632 22.0099 13.2672 22.0099 14.12 21.5299L19.84 18.3499C21.92 16.9999 21.92 16.9999 21.92 14.8899V9.10986C21.92 6.99986 21.92 6.99986 19.84 5.64986L14.12 2.46986C13.2672 1.98986 11.8632 1.98986 11 2.46986L5.27995 5.64986C3.19995 6.99986 3.19995 6.99986 3.19995 9.10986Z",
    stroke: "#0B1526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5599 15C14.2831 15 15.6799 13.6569 15.6799 12C15.6799 10.3431 14.2831 9 12.5599 9C10.8368 9 9.43994 10.3431 9.43994 12C9.43994 13.6569 10.8368 15 12.5599 15Z",
    stroke: "#0B1526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.dac91b9fa5adad6d1669f2cca27dd788.svg";
export { ForwardRef as ReactComponent };